const RELOAD_KEY = 'aibuild:lastChunkReload';
const RELOAD_COOLDOWN_MS = 10_000;

// A lazily-imported chunk can 404 when the client is on a build that's no longer
// served (a deploy removed its hashed assets). Vite emits `vite:preloadError`;
// a single hard reload pulls the fresh index.html + asset set. The cooldown
// stops a reload loop if the chunk is genuinely unfetchable.
export function reloadOnChunkError(): () => void {
  const handler: EventListener = (event) => {
    let last = 0;
    try {
      last = Number(sessionStorage.getItem(RELOAD_KEY) ?? '0');
    } catch {
      last = 0;
    }

    if (Date.now() - last < RELOAD_COOLDOWN_MS) return;

    event.preventDefault();
    try {
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch {
      // storage blocked — reload anyway; worst case is one extra reload
    }
    window.location.reload();
  };

  window.addEventListener('vite:preloadError', handler);
  return () => window.removeEventListener('vite:preloadError', handler);
}
